import backend, {PAYMENT_API} from 'utils/backend/server/api_library';

const loadCaregiverPaymentPlan = (caregiverRn) => {
  const url = `${PAYMENT_API}/payment/plan/caregiver/${caregiverRn}`;
  return backend.get(url);
};

const updateCaregiverHourlyRate = (caregiverRn, hourlyRate) => {
  const body = {
    hourlyRate,
  };
  const url = `${PAYMENT_API}/payment/plan/caregiver/${caregiverRn}/hourly`;
  return backend.post(url, body);
};

export default {
  loadCaregiverPaymentPlan: loadCaregiverPaymentPlan,
  updateCaregiverHourlyRate: updateCaregiverHourlyRate,
};
